import React from "react";
import "./PrivacyPage.css";
import { Container } from "react-bootstrap";
import { useLanguage } from "../../Context/LanguageContext";

const PrivacyPage = () => {
  const { language } = useLanguage();

  return (
    <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
      <section className="privacy-policy-section">
        {language === "en" ? (
          <div className="privacy-policy">
            <div className="policy-description">
              <div className="privacy-heading">JK SEL Privacy Policy</div>
              <div className="privacy-title">
                Our Data Collection Practices{" "}
              </div>
              <div className="privacy-description">
                <li>
                  JK SEL Co., Ltd / JK SEL INDIA Pvt. Ltd. (collectively “JK
                  SEL” or “we”) is a global software development and services
                  company. This Policy explains what information we will collect
                  about you when you visit Terms of Use.
                </li>
                {/* <br /> */}
                <li>
                  We also collect your data when you send an email, fill in our
                  contact form or apply for employment through our Website. This
                  Policy outlines how we use to collect the information, how we
                  use it, and how you, the data subject, can control our use of
                  this data. We also explain our use of cookies and any
                  limitations on our liability.
                </li>
                {/* <br /> */}
                <li>
                  Before you use our Website, we encourage you to familiarize
                  yourself with our Policy and its details. It outlines
                  specifically the extent of our use of your personal data.
                </li>
                {/* <br /> */}
                <li>
                  We include our Website Terms of Use at the end of this Policy.
                  This Policy is part of our Terms of Use. Please note that we
                  will update this policy and our Terms periodically, and we
                  urge you to read it regularly for any updates.
                </li>
              </div>
              <div className="privacy-title">How We Use Your Data</div>
              <div className="privacy-description">
                <li>
                  We follow the terms and dictates of the EU General Data
                  Protection Regulation (GDPR), which is an international
                  protocol for the safe collection and use of online data. JK
                  SEL controls and processes all personal data collected from
                  this Website and other sources. The term controller means we
                  have sole responsibility and discretion for our use of your
                  personal information.
                </li>
                {/* <br /> */}
                <li>
                  We use third-party services for recruitment and other
                  purposes. When you apply for employment, send us your resume,
                  contact us regarding employment, or otherwise engage with
                  career-related services, you agree we will collect personal
                  information about you. You also agree to our transfer and
                  sharing of this data to our third-party subsidiaries. In these
                  cases, we remain the processor of your data.
                </li>
              </div>
              <div className="privacy-title">
                Types Of Information We Collect
              </div>
              <div className="privacy-description">
                <li>
                  We only collect information that makes site navigation
                  possible or allows you to interact with our website.
                </li>
              </div>
              <div className="privacy-title">
                How And When We Collect Information
              </div>
              <div className="privacy-description">
                <li>
                  When you contact us through email, the contact form, or any
                  contact feature on our Website, you agree to provide your
                  name, phone number, email address, legal address, and other
                  personal data.
                </li>
                {/* <br /> */}
                <li>
                  If you apply for a job, we will collect your full name, work
                  history, location, examples of past work, online portfolios,
                  phone number, location, and other information you choose to
                  send us. We may also keep information about you when you refer
                  a candidate for employment or contact us on behalf of a
                  recruiting agency.
                </li>
                {/* <br /> */}
                <li>
                  As a global company, JK SEL sometimes collects information
                  from unrelated websites around the world. These might include
                  job boards, social media accounts, work referrals, online
                  reviews, and other sources. If you publish your work history
                  or work portfolio online, you often agree to provide personal
                  information that may be shared with us and others. Before you
                  sign up with online accounts or job boards, read their privacy
                  policies to understand what information they may collect and
                  share.
                </li>
              </div>
              <div className="privacy-title">
                How We Collect Data from our Websites
              </div>
              <div className="privacy-description">
                When you visit our Website, you agree to the following types of
                collection activities:
                <br />
                <br />
                <li>
                  Information about the device you’re using, including make,
                  model, and browser type.
                </li>
                {/* <br /> */}
                <li>
                  Data about how you use our Website, including your IP address,
                  geographical location, referral link, page views, and Website
                  navigation paths.
                </li>
                {/* <br /> */}
                <li>
                  Cookies. JK SEL uses cookies. An explanation about the type of
                  cookies we use is in Clause 10 of this Policy.
                </li>
              </div>
              <div className="privacy-title">When And How We Use Your Data</div>
              <div className="privacy-description">
                <li>
                  We only use your personal data in accordance with local and
                  international law. Our use depends on a legitimate legal
                  reason for using all personal data we have collected about
                  you.
                </li>
                {/* <br /> */}
                <li>
                  By availing yourself of our services, including but not
                  limited to participating in our whatsapp and other social
                  media campaigns, you hereby grant unambiguous and explicit
                  consent to the collection, processing, and utilization of your
                  personal data in accordance with the stipulations set forth in
                  this privacy policy. Pursuant to the applicable data
                  protection laws in the respective jurisdictions where we
                  operate, explicit consent will be sought for any usage of your
                  data that deviates from the purposes originally delineated
                  herein.
                </li>
                {/* <br /> */}
                <li>
                  When we collect information about you from our Website, third
                  parties, or outside sources, we will use it only in accordance
                  with the limitations of the GDPR regarding legitimate business
                  use, recruitment, legitimate business interests, marketing
                  purposes, investor relations, and security protocols.
                </li>
                {/* <br /> */}
                <li>
                  When you visit our Websites, JK SEL may place cookies and
                  other codes on your browser or device. These codes,
                  collectively known as “Cookies,” may also appear on unrelated
                  websites you visit. Cookies help improve the user experience,
                  streamline your online browsing, personalise your online
                  profile and otherwise enhance your experience as a Website
                  visitor. Cookies permit us to analyse our Websites, monitor
                  our marketing approaches, understand our visitor patterns and
                  improve the security of our Websites. If you have questions
                  about the Cookies we use and how long we retain them, please
                  contact us.
                </li>
              </div>
              {/* <br /> */}
              <div className="privacy-title">
                Retention Of Your Personal Records
              </div>
              <div className="privacy-description">
                <li>
                  This section concerns the retention and processing of your
                  data. The term processing refers to our collection, recording,
                  retention, organization, and storage of your personal data. It
                  also includes our ability to adapt, alter, erase or delete
                  your personal information.
                </li>
                {/* <br /> */}
                <li>
                  As an global company, we may transmit or transfer your
                  personal information to outside websites and companies. Our
                  transference of your personal data will always comply with
                  laws regarding data protection and transmission.
                </li>
                {/* <br /> */}
                <li>
                  We may disclose your personal data to some of our clients for
                  business engagement or to confirm the high skill levels of our
                  team members. We may also display them to auditors, agencies,
                  supervisory authorities, or other external service providers
                  as required by our contractual obligations.
                </li>
                {/* <br /> */}
                <li>
                  We may also disclose your personal data if we are required by
                  law to disclose it.
                </li>
                {/* <br /> */}
                <li>
                  We will share your information when necessary to exercise our
                  legal rights, protect our data, prevent fraud and reduce our
                  risk of liability.
                </li>
                {/* <br /> */}
                <li>
                  We will share your personal data when required by a criminal
                  investigation, legal proceeding, or other legal obligation.
                </li>
              </div>
              <div className="privacy-title">Your Rights As A Data Subject</div>
              <div className="privacy-description">
                You also have rights under this Policy. They include the rights
                to:
                <br />
                <br />
                <li>
                  Ask what information we have about you. You may ask us to
                  explain what information we are keeping, why we are keeping
                  it, and how we are using it.
                </li>
                {/* <br /> */}
                <li>
                  View your personal information. You have the right to see the
                  data we have stored about you. You can ensure the information
                  is accurate and that we’re using the information in a legal
                  manner.
                </li>
                {/* <br /> */}
                <li>
                  Update or correct the information. If our data is incorrect or
                  outdated, you may request a correction.
                </li>
                {/* <br /> */}
                <li>
                  Ask us to delete your data. You may request deletion of your
                  personal information if there is no legitimate need for us to
                  retain it. You can also request the deletion when you exercise
                  your right to object to processing.
                </li>
                {/* <br /> */}
                <li>
                  Object to processing. This term refers to a situation where
                  your personal circumstances make you unwilling or unable to
                  agree to the retention and transmission of your personal
                  information, even when we have a legitimate interest in
                  keeping it. You may also use this right to limit the extent of
                  our transmission and sharing of your personal data. For
                  instance, you may object to our sharing of your personal data
                  with specific corporate or government entities.
                </li>
                {/* <br /> */}
                <li>
                  Suspend our processing. You may request a suspension of our
                  use of your personal data for various reasons. For instance,
                  if you want to review your personal data to ensure we’re using
                  it legally or in compliance with this Policy, you can request
                  a suspension of our use while you investigate.
                </li>
                {/* <br /> */}
                <li>
                  Request your information. You may ask us to send your profile
                  to you in a usable electronic format at any time. You may also
                  ask us to transfer or transmit this profile to a third party
                  of your choice. The data must be in a usable electronic
                  format.
                </li>
                {/* <br /> */}
                <li>
                  Withdraw your consent. At any time, you may ask us to stop
                  collecting, processing, or transmitting your personal
                  information. We will stop all collection, processing, and
                  transmission upon request. We will stop or suspend this
                  processing and collection for any of the purposes you
                  originally agreed to, unless we have a legitimate, legal
                  business interest in continuing to use your information.
                </li>
                {/* <br /> */}
                If you want to exercise any of these rights, please email us at
                info@jkselab.com. We typically respond in three to four weeks.
              </div>
              <div className="privacy-title">Please note the following:</div>
              <div className="privacy-description">
                We may request additional information to ensure your identity.
                We will do so to ensure you are the authorized owner of this
                information and have the right to view it or withdraw consent.
                This is a security measure that protects your personal
                information from unlawful disclosure to people who do not have
                the right to see it. We will respond to your exercise of your
                rights in accordance with the law. We will not comply with
                requests that are not legally valid.
              </div>
              <div className="privacy-title">
                Data Usage for Social Media Campaigns:
              </div>
              <div className="privacy-description">
                We reserve the right to utilize your contact information,
                including but not limited to your phone number, for the purpose
                of disseminating promotional and informational content via
                WhatsApp and other social media platforms. Your data will be
                employed exclusively for the objectives of these campaigns and
                shall not be divulged to third-party entities without your
                explicit consent. You retain the right to withdraw your consent
                and discontinue participation in these campaigns at any time by
                notifying us.
              </div>
              <div className="privacy-title">How We Protect Your Data</div>
              <div className="privacy-description">
                <li>
                  We use the strictest security protocols to protect all
                  personal data we retain and transmit. We use strict security
                  measures to prevent fraudulent use of this data. Our storage
                  and transmission techniques are designed to prevent the
                  unlawful copying, destruction, alteration, or corruption of
                  all personal profiles.
                </li>
                {/* <br /> */}
                <li>
                  We will store your personal data on our servers or the servers
                  of our affiliates. JK SEL may share this data on cloud-based
                  storage systems we exchange with our clients, third parties,
                  service providers, subsidiaries, and other affiliates.
                </li>
                {/* <br /> */}
                <li>
                  To determine how long we will keep your information, we
                  consider the type, amount, and nature of your personal
                  information. Our protocols ensure differing levels of security
                  measures that depend on the sensitivity of this data. We will
                  only keep your data in storage and process it for as long as
                  necessary to meet our business and other obligations.
                </li>
                {/* <br /> */}
                <li>
                  We may keep personal data when we are required to do so by
                  legal and regulatory obligations. In the case of a legal or
                  civil claim, we will use your personal data as needed to meet
                  our legal and contractual obligations. Your data may help us
                  process responses to charges and complaints. When we have met
                  these legal and contractual obligations, we will destroy your
                  data in a secure manner.
                </li>
                {/* <br /> */}
                <li>
                  {" "}
                  Your data may help us process responses to charges and
                  complaints. When we have met these legal and contractual
                  obligations, we will destroy your data in a secure manner.
                </li>
                {/* <br /> */}
                <li>
                  We may use your personal data when necessary to exercise or
                  defend our legal rights, to provide information related to an
                  investigation, or to comply with other legal proceedings.
                </li>
                {/* <br /> */}
                <li>
                  We may process and transmit your personal information when
                  necessary to take measures that prevent fraud and corruption.
                </li>
              </div>
            </div>
          </div>
        ) : (
          <div className="privacy-policy">
            <div className="policy-description">
              <div className="privacy-heading">
                JK셀 주식회사 개인정보 보호정책
              </div>
              <div className="privacy-title">데이터 수집 방법 및 관행</div>
              <div className="privacy-description">
                <li>
                  JK SEL Co., Ltd 및 JK SEL INDIA Pvt. Ltd."(통칭 "JK셀" 또는
                  ”우리”)은 글로벌 소프트웨어 개발 및 서비스 회사입니다. 본
                  정책은 사용자가 이용 약관에 방문할 때 우리가 귀하로부터
                  수집하는 정보에 대해 설명합니다.
                </li>
                {/* <br /> */}
                <li>
                  또한, 우리는 귀하가 이메일을 보내거나, 문의 양식을 작성하거나,
                  우리의 웹사이트를 통해 채용에 지원할 때 귀하의 데이터를
                  수집합니다. 본 정책은 정보 수집 방식, 정보 사용 방법, 그리고
                  데이터 주체인 귀하가 우리의 데이터 사용을 어떻게 통제할 수
                  있는지에 대해 설명합니다. 또한, 쿠키 사용 및 우리의 책임에
                  대한 제한 사항도 안내합니다.
                </li>
                {/* <br /> */}
                <li>
                  우리의 웹사이트를 사용하기 전에 본 정책과 그 세부 사항을
                  숙지하시기를 권장합니다. 이 정책은 귀하의 개인 데이터를
                  사용하는 범위에 대해 구체적으로 설명합니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 본 정책의 끝부분에 웹사이트 이용 약관을 포함하고
                  있습니다. 본 정책은 우리의 이용 약관의 일부입니다. 이 정책과
                  이용 약관은 주기적으로 업데이트되므로, 변경 사항을 확인하기
                  위해 정기적으로 읽어 보시기를 권장합니다.
                </li>
              </div>
              <div className="privacy-title">데이터를 사용하는 방식</div>
              <div className="privacy-description">
                <li>
                  우리는 온라인 데이터의 안전한 수집 및 사용을 위한 국제적
                  프로토콜인 EU 일반 데이터 보호 규정(GDPR)의 조항과 지침을
                  준수합니다. JK셀은 이 웹사이트 및 기타 출처에서 수집된 모든
                  개인 데이터를 통제하고 처리합니다. 여기서 통제자라는 용어는
                  우리가 귀하의 개인 정보를 사용하는 데 있어 전적인 책임과
                  재량을 가진다는 것을 의미합니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 채용 및 기타 목적을 위해 제3자 서비스를 이용합니다.
                  귀하가 채용에 지원하거나, 이력서를 보내거나, 채용 관련 문의를
                  하거나, 기타 경력 관련 서비스에 참여할 경우, 우리가 귀하의
                  개인 정보를 수집하는 것에 동의한 것으로 간주됩니다. 또한,
                  귀하는 이 데이터를 우리의 제3자 계열사로 이전 및 공유하는 것에
                  동의한 것으로 간주됩니다. 이 경우, 우리는 여전히 귀하의 데이터
                  처리자로서 역할을 수행합니다.
                </li>
              </div>
              <div className="privacy-title">수집하는 정보의 종류</div>
              <div className="privacy-description">
                <li>
                  우리는 사이트 검색을 가능하게 하거나 귀하가 우리의 웹사이트와
                  상호작용할 수 있도록 하는 정보만을 수집합니다.
                </li>
              </div>
              <div className="privacy-title">정보 수집 방법 및 시점</div>
              <div className="privacy-description">
                <li>
                  우리는 사이트 검색을 가능하게 하거나 귀하가 우리의 웹사이트와
                  상호작용할 수 있도록 하는 정보만을 수집합니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하가 채용에 지원할 경우, 우리는 귀하의 성명, 경력 사항,
                  위치, 과거 작업 예시, 온라인 포트폴리오, 전화번호, 위치 및
                  귀하가 제공하는 기타 정보를 수집합니다. 또한, 귀하가 채용
                  후보자를 추천하거나 채용 대행사를 대표하여 우리에게 연락할
                  경우, 귀하에 관한 정보를 보관할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  글로벌 회사인 JK셀은 가끔 전 세계의 관련 없는 웹사이트에서
                  정보를 수집합니다. 이러한 정보에는 구인 게시판, 소셜 미디어
                  계정, 직업 추천, 온라인 리뷰 및 기타 출처가 포함될 수
                  있습니다. 귀하가 온라인에 자신의 경력 사항이나 작업
                  포트폴리오를 게시할 경우, 종종 우리와 다른 사람들과 공유될 수
                  있는 개인 정보를 제공하는 것에 동의한 것입니다. 온라인
                  계정이나 구인 게시판에 가입하기 전에, 그들의 개인정보
                  보호정책을 읽고 그들이 어떤 정보를 수집하고 공유할 수 있는지
                  이해하시기 바랍니다.
                </li>
              </div>
              <div className="privacy-title">
                웹사이트에서 데이터를 수집하는 방식
              </div>
              <div className="privacy-description">
                우리의 웹사이트를 방문하면, 귀하는 다음과 같은 유형의 수집
                활동에 동의한 것으로 간주됩니다:
                <br />
                <br />
                <li>
                  귀하가 사용하고 있는 기기에 대한 정보, 예를 들어 제조사, 모델,
                  브라우저 유형 등
                </li>
                {/* <br /> */}
                <li>
                  우리의 웹사이트 사용에 관한 데이터, 예를 들어 IP 주소, 지리적
                  위치, 참조 링크, 페이지 조회수 및 웹사이트 탐색 경로 등.
                </li>
                {/* <br /> */}
                <li>
                  쿠키. JK셀은 쿠키를 사용합니다. 우리가 사용하는 쿠키의 종류에
                  대한 설명은 본 정책의 제10조에 있습니다.
                </li>
              </div>
              <div className="privacy-title">
                귀하의 데이터를 사용하는 시기와 방법
              </div>
              <div className="privacy-description">
                <li>
                  우리는 귀하의 개인 데이터를 지역 및 국제 법률에 따라서만
                  사용합니다. 우리가 귀하에 대해 수집한 모든 개인 데이터를
                  사용하는 것은 합법적인 법적 이유에 달려 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리의 서비스, 특히 WhatsApp 및 기타 소셜 미디어 캠페인에
                  참여하는 것 등을 포함하되 이에 국한되지 않는 서비스를
                  이용함으로써, 귀하는 본 개인정보 보호정책에 명시된 규정에 따라
                  귀하의 개인 데이터를 수집, 처리 및 활용하는 데 명확하고
                  명시적인 동의를 제공합니다. 우리가 운영하는 각 관할 구역에서
                  적용되는 데이터 보호법에 따라, 본 정책에서 처음에 정의된
                  목적에서 벗어난 데이터 사용에 대해 명시적인 동의를 받을
                  것입니다.
                </li>
                {/* <br /> */}
                <li>
                  우리가 귀하에 대한 정보를 웹사이트, 제3자 또는 외부 출처에서
                  수집할 때, 우리는 이를 GDPR의 제한 사항에 따라 합법적인
                  비즈니스 용도, 채용, 합법적인 비즈니스 이익, 마케팅 목적,
                  투자자 관계 및 보안 프로토콜에만 사용할 것입니다.
                </li>
                {/* <br /> */}
                <li>
                  우리의 웹사이트를 방문하면, JK셀은 귀하의 브라우저나 기기에
                  쿠키 및 기타 코드를 배치할 수 있습니다. 이 코드는 총칭하여
                  "쿠키"라고 불리며, 귀하가 방문하는 관련 없는 웹사이트에도
                  나타날 수 있습니다. 쿠키는 사용자 경험을 개선하고, 온라인
                  탐색을 간소화하며, 온라인 프로필을 개인화하고, 웹사이트
                  방문자로서의 경험을 향상시키는 데 도움을 줍니다. 쿠키는 우리의
                  웹사이트를 분석하고, 마케팅 접근 방식을 모니터링하며, 방문자
                  패턴을 이해하고, 웹사이트의 보안을 개선하는 데 사용됩니다.
                  우리가 사용하는 쿠키와 그 보유 기간에 대해 궁금한 점이 있으면
                  저희에게 연락해 주세요.
                </li>
              </div>
              {/* <br /> */}
              <div className="privacy-title">귀하의 개인 기록 보유사항</div>
              <div className="privacy-description">
                <li>
                  이 항목은 귀하의 데이터 보유 및 처리에 관한 내용입니다.
                  "처리"란 귀하의 개인 데이터를 수집, 기록, 보유, 조직화 및
                  저장하는 것을 의미합니다. 또한 귀하의 개인 정보를 수정, 변경
                  또는 삭제할 수 있는 것을 포함합니다.
                </li>
                {/* <br /> */}
                <li>
                  글로벌 회사로서, 우리는 귀하의 개인 정보를 외부 웹사이트와
                  회사로 전송하거나 전달할 수 있습니다. 귀하의 개인 데이터
                  전송은 항상 데이터 보호 및 전송에 관한 법률을 준수하여
                  이루어집니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 비즈니스 협력을 위해서, 또는 우리팀 구성원의 높은 기술
                  수준을 확인하기 위해 귀하의 개인 데이터를 일부 고객에게 공개할
                  수 있습니다. 또한, 계약상 의무에 따라 감사인, 기관, 감독 당국
                  또는 기타 외부 서비스 제공자에게 이를 표시할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 법적으로 공개가 요구되는 경우 귀하의 개인 데이터를
                  공개할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 법적 권리를 행사하고, 데이터를 보호하며, 사기를
                  방지하고, 책임 위험을 줄이기 위해 필요한 경우 귀하의 정보를
                  공유할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 범죄 조사, 법적 절차 또는 기타 법적 의무가 요구되는
                  경우 귀하의 개인 데이터를 공유할 수 있습니다.
                </li>
              </div>
              <div className="privacy-title">데이터 주체로서 귀하의 권리</div>
              <div className="privacy-description">
                귀하는 본 정책에 따라 권리를 가지고 있습니다. 이 권리에는 다음이
                포함됩니다:
                <br />
                <br />
                <li>
                  귀하에 대해 우리가 가지고 있는 정보를 요청할 수 있습니다.
                  귀하는 우리가 어떤 정보를 보유하고 있는지, 왜 그것을 보유하고
                  있는지, 그리고 어떻게 사용하고 있는지 설명해 달라고 요청할 수
                  있습니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하의 개인 정보를 조회할 수 있습니다. 귀하는 우리가 보유한
                  데이터를 확인할 권리가 있습니다. 또한, 정보가 정확한지
                  확인하고 우리가 그 정보를 합법적인 방식으로 사용하고 있는지
                  점검할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  정보를 업데이트하거나 수정할 수 있습니다. 만약 우리의 데이터가
                  부정확하거나 오래된 경우, 수정 요청을 할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하의 데이터를 삭제해 달라고 요청할 수 있습니다. 만약 우리가
                  데이터를 보유할 합법적인 필요가 없을 경우, 귀하는 개인 정보
                  삭제를 요청할 수 있습니다. 또한, 처리에 대한 이의를 제기할 때
                  데이터를 삭제해 달라고 요청할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  이 용어는 귀하의 개인적인 상황으로 인해 우리가 귀하의 개인
                  정보를 보유하고 전송하는 것에 동의할 수 없거나 동의하고 싶지
                  않은 경우를 의미합니다. 이는 우리가 데이터를 보유할 합법적인
                  이익이 있더라도 마찬가지입니다. 또한, 이 권리를 사용하여
                  귀하의 개인 데이터를 전송하고 공유하는 범위를 제한할 수
                  있습니다. 예를 들어, 귀하는 특정 기업 또는 정부 기관과 귀하의
                  개인 데이터를 공유하는 것에 대해 이의를 제기할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하는 다양한 이유로 우리가 귀하의 개인 데이터를 사용하는 것을
                  일시 중지할 것을 요청할 수 있습니다. 예를 들어, 우리가 귀하의
                  개인 데이터를 합법적으로 사용하고 있는지 또는 본 정책을
                  준수하는지 검토하고자 할 경우, 조사를 하는 동안 우리의 데이터
                  사용 중단을 요청할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하는 언제든지 사용 가능한 전자 형식으로 귀하의 프로필을 보내
                  달라고 요청할 수 있습니다. 또한, 이 프로필을 귀하가 선택한
                  제3자에게 전송하거나 전달해 달라고 요청할 수 있습니다.
                  데이터는 사용 가능한 전자 형식이어야 합니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하는 언제든지 우리가 귀하의 개인 정보를 수집, 처리 또는
                  전송하는 것을 중단해 달라고 요청할 수 있습니다. 요청 시,
                  우리는 모든 수집, 처리 및 전송을 중단할 것입니다. 귀하가 원래
                  동의한 목적에 대해 이 처리와 수집을 중단하거나 일시
                  중지하겠지만, 우리가 귀하의 정보를 계속 사용해야 할 합법적이고
                  법적인 비즈니스 이익이 있는 경우에는 제외됩니다.
                </li>
                {/* <br /> */}위 사항 중에 권리를 행사하려면,
                info@jkselab.com으로 이메일을 보내주십시오. 보통 3~4주 이내에
                답해 드리겠습니다.
              </div>
              <div className="privacy-title">다음 사항을 유의하십시오:</div>
              <div className="privacy-description">
                우리는 귀하의 신원을 확인하기 위해 추가 정보를 요청할 수
                있습니다. 이는 귀하가 해당 정보의 권한 있는 소유자이며 이를
                열람하거나 동의를 철회할 권리가 있음을 확인하기 위함 입니다.
                이는 귀하의 개인 정보가 불법적으로 열람되는 것을 방지하기 위한
                보안 조치입니다. 우리는 귀하의 권리 행사를 법에 따라 응답할
                것입니다. 법적으로 유효하지 않은 요청에는 응답하지 않습니다.
              </div>
              <div className="privacy-title">
                소셜 미디어 캠페인에 대한 데이터 사용:
              </div>
              <div className="privacy-description">
                우리는 귀하의 연락처 정보, 전화번호를 포함하되 이에 국한되지
                않는 정보를 WhatsApp 및 기타 소셜 미디어 플랫폼을 통해 홍보 및
                정보 콘텐츠를 전파하는 목적으로 사용할 권리를 보유합니다. 귀하의
                데이터는 이러한 캠페인의 목적에만 사용되며, 귀하의 명시적인 동의
                없이 제3자에게 공개되지 않습니다. 귀하는 언제든지 동의를
                철회하고, 우리에게 통지함으로써 이러한 캠페인에 대한 참여를
                중단할 권리를 가집니다.
              </div>
              <div className="privacy-title">
                우리가 귀하의 데이터를 보호하는 방법
              </div>
              <div className="privacy-description">
                <li>
                  우리는 우리가 보유하고 전송하는 모든 개인 데이터를 보호하기
                  위해 가장 엄격한 보안 프로토콜을 사용합니다. 우리는 이
                  데이터를 부정하게 사용하는 것을 방지하기 위해 엄격한 보안
                  조치를 취합니다. 우리의 저장 및 전송 기술은 모든 개인 프로필의
                  불법적인 복제, 파괴, 변경 또는 손상을 방지하도록
                  설계되었습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 귀하의 개인 데이터를 우리의 서버 또는 우리의 계열사의
                  서버에 저장할 것입니다 .JK셀은 클라우드 기반 저장 시스템을
                  통해 이 데이터를 우리의 고객, 제3자, 서비스 제공업체, 자회사
                  및 기타 계열사와 교환할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 귀하의 정보를 얼마나 오래 보관할지 결정하기 위해,
                  귀하의 개인 정보의 유형, 크기 및 성격을 고려합니다. 우리의
                  프로토콜은 이 데이터의 민감성에 따라 다양한 보안 수준을
                  보장합니다. 우리는 비즈니스 및 기타 의무를 충족하는 데 필요한
                  기간 동안만 귀하의 데이터를 저장하고 처리할 것입니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 법적 및 규제 의무에 의해 요구되는 경우 개인 데이터를
                  보관할 수 있습니다. 법적 또는 민사적 청구가 있는 경우, 우리는
                  법적 및 계약적 의무를 충족하기 위해 귀하의 개인 데이터를
                  필요에 따라 사용할 것입니다. 귀하의 데이터는 고발 및 불만
                  처리에 도움이 될 수 있습니다. 이러한 법적 및 계약적 의무를
                  충족한 후, 우리는 귀하의 데이터를 안전한 방식으로 삭제할
                  것입니다.
                </li>
                {/* <br /> */}
                <li>
                  {" "}
                  귀하의 데이터는 고발 및 불만 처리에 도움이 될 수 있습니다.
                  이러한 법적 및 계약적 의무를 충족한 후, 우리는 귀하의 데이터를
                  안전한 방식으로 삭제할 것입니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 법적 권리를 행사하거나 방어하기 위해, 조사와 관련된
                  정보를 제공하기 위해, 또는 기타 법적 절차를 준수하기 위해
                  귀하의 개인 데이터를 사용할 수 있습니다.
                </li>
                {/* <br /> */}
                <li>
                  우리는 사기 및 부패방지를 위한 조치를 취하는데, 필요할 경우
                  귀하의 개인 정보를 처리하고 전송할 수 있습니다.
                </li>
              </div>
            </div>
          </div>
        )}
      </section>
    </Container>
  );
};

export default PrivacyPage;
